import lax from 'lax.js';
import * as React from 'react';

function useLax(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      drivers = _ref.drivers,
      elements = _ref.elements;

  React.useEffect(function () {
    if (!window.lax) {
      window.lax = lax;
    }
  }, []);
  React.useEffect(function () {
    lax.init();

    if (drivers != null && drivers.length) {
      drivers.forEach(function (_ref2) {
        var name = _ref2.name,
            getValueFn = _ref2.getValueFn,
            options = _ref2.options;
        lax.addDriver(name, getValueFn, options);
      });
    }

    if (elements != null && elements.length) {
      elements.forEach(function (_ref3) {
        var selector = _ref3.selector,
            animationData = _ref3.animationData,
            options = _ref3.options;
        lax.addElements(selector, animationData, options);
      });
    }
  }, []);
}

function useLaxElement(_temp2) {
  var _ref4 = _temp2 === void 0 ? {} : _temp2,
      animationData = _ref4.animationData,
      options = _ref4.options;

  var ref = React.useRef();
  React.useEffect(function () {
    var currentNode = ref.current;

    if (currentNode) {
      lax.addElement(currentNode, animationData, options);
    }

    return function () {
      if (currentNode) {
        lax.removeElement(currentNode);
      }
    };
  }, []);
  return ref;
}

export { useLax, useLaxElement };
